import { Injectable } from '@angular/core';
import { BaseRequestOptions, RequestOptions, RequestOptionsArgs } from '@angular/http';
import { AuthService } from './auth.service';

const AUTHORIZATION_HEADER = 'authorization';
const SESSION_TOKEN_HEADER = 'sessionToken';

@Injectable()
export class CustomRequestOptions extends BaseRequestOptions {
  constructor(private auth: AuthService) {
    super();
  }

  merge(options?: RequestOptionsArgs): RequestOptions {
    console.log('CustomRequestOptions: Incoming...');
    if (this.auth.getToken()) {
      this.headers.append(AUTHORIZATION_HEADER, `Bearer ${this.auth.getToken()}`);
      this.headers.append(SESSION_TOKEN_HEADER, `${this.auth.getToken()}`);
    } else {
      this.headers.delete(AUTHORIZATION_HEADER);
      this.headers.delete(SESSION_TOKEN_HEADER);
    }

    return super.merge(options);
  }
}
